import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE, } from "../Types";
  
  const initialState = {
    loading: false,
    error: null,
    message: null,
  };
  
  const ResetPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
      case RESET_PASSWORD_REQUEST:
        return { ...state, loading: true, error: null, message: null };
  
      case RESET_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          message: action.payload.message,
          error: null,
        };
  
      case RESET_PASSWORD_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          message: null,
        };
  
      default:
        return state;
    }
  };
  
  export default ResetPasswordReducer;
  